import React from "react";
import {graphql} from "gatsby";
import StructuredText from "../custom-structured-text-renderer";
import parse from "html-react-parser";
import {Asset, MediaItem} from "../../../../plugins/gatsby-plugin-atollon";

const TitleContentVideo = ({video, title, reverse, richContent, image, videoEmbed}) => {
    return (
        <section className='title-content-video'>
          <div className={`title-content-video__inner ${reverse ? 'title-content-video__reverse' : ''}`}>
              <div className='title-content-video__content' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                  {title && <h3>{parse(title)}</h3>}
                  {richContent && <StructuredText data={richContent}/>}
              </div>

              <div className='title-content-video__video' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                {video && !videoEmbed && <video src={video} autoPlay loop muted playsInline/>}
                {videoEmbed && <MediaItem item={videoEmbed} videoThumbnail={video ? video : null}/> }
                {image && <Asset asset={image}/>}
              </div>
          </div>
        </section>
    )
}

export default TitleContentVideo

export const query = graphql`
fragment TitleContentVideoProps on DatoCmsTitleContentVideo {
  ... on DatoCmsTitleContentVideo {
    id
    video
    title
    reverse
    richContent {
      value
    }
    image {
      ...InternalAssetProps
    }
    videoEmbed {
      ...MediaItemProps
    }
  }
}
`